import { createSelector } from 'reselect';
import { subselect } from './root';
import { propertiesSelector } from './properties';

const stitcherParamsSelector = createSelector(
  [propertiesSelector],
  ({ setup = {} }) => setup.stitcherParams || {},
);

export const applicationStitcherParamsSelector = subselect(stitcherParamsSelector);
